(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/react/carousel-navigation.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/react/carousel-navigation.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const _svs$ui = svs.ui,
  IconButton = _svs$ui.ReactIconButton,
  Icon = _svs$ui.ReactIcon;
const CarouselNavigationItem = svs.components.lbUi.carousel.CarouselNavigationItem;
const usePrevious = svs.components.lbUtils.usePrevious.usePrevious;
const clx = svs.components.lbUtils.clx;
const CarouselNavigation = _ref => {
  let disabled = _ref.disabled,
    isKeyNav = _ref.isKeyNav,
    numberOfPages = _ref.numberOfPages,
    onChange = _ref.onChange,
    selectedIndex = _ref.selectedIndex,
    size = _ref.size;
  const ref = useRef(null);
  const dots = useRef(null);
  const _useState = useState(selectedIndex),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  const currentIndex = selectedIndex > numberOfPages - 1 ? numberOfPages - 1 : selectedIndex;
  const pageIndexes = [...Array(numberOfPages).keys()];
  const lastIndex = usePrevious(currentIndex);
  const previous = useCallback(() => {
    if (currentIndex > 0) {
      onChange(currentIndex - 1);
    }
  }, [onChange, currentIndex]);
  const next = useCallback(() => {
    if (currentIndex + 1 < numberOfPages) {
      onChange(currentIndex + 1);
    }
  }, [numberOfPages, onChange, currentIndex]);

  useEffect(() => {
    const nav = ref === null || ref === void 0 ? void 0 : ref.current;
    const onKeyboardNavigation = e => {
      switch (e.key) {
        case 'ArrowLeft':
          setActiveIndex(prev => {
            const nextIndex = prev - 1;
            return nextIndex < 0 ? numberOfPages - 1 : nextIndex;
          });
          break;
        case 'ArrowRight':
          setActiveIndex(prev => (prev + 1) % numberOfPages);
          break;
        default:
      }
    };
    nav.addEventListener('keyup', onKeyboardNavigation);
    return () => {
      nav.removeEventListener('keyup', onKeyboardNavigation);
    };
  }, [numberOfPages]);

  useEffect(() => {
    var _document$activeEleme;
    const focusInNavigation = (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.closest('.carousel-nav');
    if (focusInNavigation === ref.current && isKeyNav) {
      dots.current.children[activeIndex].firstChild.focus();
    }
  }, [isKeyNav, lastIndex, activeIndex]);
  return React.createElement("div", {
    "aria-label": "Sida ".concat(currentIndex + 1, " of ").concat(numberOfPages),
    "aria-roledescription": "Karusellnavigation",
    className: clx('carousel-nav', {
      'carousel-nav-disabled': disabled
    }),
    "data-testid": "carousel-navigation",
    ref: ref,
    role: "navigation"
  }, React.createElement(IconButton, {
    "aria-label": "F\xF6reg\xE5ende sida",
    "data-testid": "carousel-navigation-previous",
    onClick: previous,
    tabIndex: -1
  }, React.createElement(Icon, {
    icon: "menu-left",
    size: size
  })), React.createElement("ul", {
    className: "carousel-nav-dots",
    "data-testid": "carousel-navigation-dots",
    ref: dots
  }, pageIndexes.map(pageIndex => React.createElement("li", {
    key: "page-".concat(pageIndex)
  }, React.createElement(CarouselNavigationItem, {
    index: pageIndex,
    isActive: pageIndex === activeIndex || pageIndexes.length === 1,
    isSelected: pageIndex === currentIndex || pageIndexes.length === 1,
    label: "Visa sida ".concat(pageIndex + 1, " av ").concat(numberOfPages),
    onChange: onChange,
    size: size
  })))), React.createElement(IconButton, {
    "aria-label": "N\xE4sta sida",
    "data-testid": "carousel-navigation-next",
    onClick: next,
    tabIndex: -1
  }, React.createElement(Icon, {
    icon: "menu-right",
    size: size
  })));
};
CarouselNavigation.defaultProps = {
  numberOfPages: 1,
  selectedIndex: 0,
  size: '300'
};
setGlobal('svs.components.lbUi.carousel.CarouselNavigation', CarouselNavigation);

 })(window);